import { extractPatientIdFromUrl } from "../utils/helpers";
import { get, post } from "./base";

export const getPlans = async (filters) => {
  try {
    const patientId = extractPatientIdFromUrl();
    const response = await get(`/PlanesCuidado/listado?afiliado=${patientId}`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.codigo,
      label: item.nombre,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de planes:", error);
  }
};

export const getTiposUnitCode = async () => {
  try {
    const response = await get(`/Code/tipos/unidades`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de tipos unidades de medida:", error);
  }
};

export const getUnitCode = async (tipo) => {
  try {
    let url = "/Code/unidades";
    if (tipo) {
      url += `?tipo=${tipo}`;
    }
    const response = await get(url);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));
    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de unidades de medida:", error);
    throw error;
  }
};


export const getClinicResultsTypeCode = async () => {
  try {
    const response = await get(`/Code/tipos/resultados/clinicos`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error(
      "Error obteniendo listado de tipos resultado clinicos:",
      error,
    );
  }
};

export const getClinicResultsCode = async (afiliado, tipo) => {
  try {
    const response = await get(`/Code/resultados/clinicos?afiliado=${afiliado}&tipo=${tipo}`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.codigo,
      label: item.descripcion,
      tipo: item.tipoPregunta
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de resultados clinicos:", error);
  }
};

export const getComorbilidadesCode = async (tipo) => {
  try {
    const response = await get(`/Code/comorbilidades?tipo=${tipo}`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de comorbilidades:", error);
  }
};

export const getComorbilidadesTypeCode = async () => {
  try {
    const response = await get(`/Code/tipos/comorbilidades`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de tipos comorbilidades:", error);
  }
};

export const obtenerMetas = async () => {
  try {
    const response = await get(`/Code/metas`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de metas:", error);
  }
};


export const obtenerListadoSustancias = async () => {
  try {
    const response = await get(`/Code/sustancias`);
    const data = await response.data;
    const formattedOptions = data.map((item) => ({
      value: item.key,
      label: item.value,
    }));

    return formattedOptions;
  } catch (error) {
    console.error("Error obteniendo listado de sustancias:", error);
  }
};

